
/**
 * get element offset object
 * @param {*} elem
 */
export const elemOffset = function (elem) {
  let bounding = elem.getBoundingClientRect();

  return {
    top: bounding.top,
    left: bounding.left,
    right: bounding.right,
    bottom: bounding.bottom,
    width: elem.offsetWidth,
    height: elem.offsetHeight,
    scrollTop: elem.scrollTop
  };
};

/**
 * get element bounds object
 * @param {*} elem
 */
export const elemBounds = function (elem) {
  let bounding = elem.getBoundingClientRect();
  let topBounds = bounding.top >= 0;
  let leftBounds = bounding.left >= 0;
  let bottomBounds = bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
  let rightBounds = bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
  let isInBounds = topBounds && leftBounds && bottomBounds && rightBounds;

  return {
    isInBounds: isInBounds,
    left: leftBounds,
    right: rightBounds,
    top: topBounds,
    bottom: bottomBounds
  };
};
